import React from "react";
import { Grid, TextField } from "@mui/material";
import BottleOrderAttachmentsTable from "./BottleOrderAttachmentsTable";
import { fieldSx } from "./bottleOrderFormHelpers";

const CommentsAttachmentsStep = ({ formData, handleChange, orderNumber }) => (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <TextField fullWidth size="small" variant="outlined" label="Comments"
                value={formData.comments} onChange={handleChange("comments")}
                multiline rows={3} sx={fieldSx} />
        </Grid>
        {orderNumber != null && (
            <Grid item xs={12}>
                <BottleOrderAttachmentsTable orderNumber={orderNumber || 0} />
            </Grid>
        )}
    </Grid>
);

export default CommentsAttachmentsStep;
